import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-9",
  "use": "menu-9-usage",
  "viewBox": "0 0 112 112",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 112 112\" id=\"menu-9\"><title>资源 108</title><g id=\"menu-9_图层_2\" data-name=\"图层 2\"><g id=\"menu-9_图层_1-2\" data-name=\"图层 1\"><path d=\"M74.56,53.28h11l22.14-19.07a57.68,57.68,0,0,0-3.28-6.57L75,52.88l-.46.4ZM58.71,0V9l9-7.78a57,57,0,0,0-9-1.2Zm46.36,53.28,6.39-5.5a54.08,54.08,0,0,0-1.78-7.84L94.17,53.28h10.9ZM86.77,9.14,58.71,33.26v9.43L92.57,13.51a56.32,56.32,0,0,0-5.8-4.37ZM74.32,3,58.71,16.41v9.43L81.57,6.13A56.32,56.32,0,0,0,74.32,3Zm26.91,19.91a55.75,55.75,0,0,0-4.53-5.43l-38,32.65v3.17h7.23ZM53.41,0a55.95,55.95,0,0,0-41.5,90.4l41.5-35.69ZM57,58.58,15.36,94.42A56,56,0,0,0,112,58.58Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-9.svg
// module id = d3mQ
// module chunks = 268